import { Button, HeroLayout, Map, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { LocalStats } from './components/LocalStats';
import { usePageHeading } from './hooks/usePageHeading';

export const PageHeading: React.FC = () => {
	const {
		data: { displayName, location },
	} = usePageHeading();

	return (
		<div className="md:mt-16">
			<HeroLayout
				media={
					location && (
						<div className="flex h-[242px] select-none items-center justify-center md:h-full xl:h-[400px]">
							<Map defaultCenter={location} disableInteractivity defaultZoom={9} showAttribution={false} />
						</div>
					)
				}
				reverseMd
				fullWidthMediaSm
				variant="1/3"
				className="bg-background-raised"
			>
				<div className="bg-background-raised relative flex-shrink-0 flex-grow-0 basis-1/2">
					<div className="flex h-full flex-col items-start gap-6 p-6 md:p-12">
						<Text
							as="h1"
							variant="heading"
							size="x-large"
							className="text-typography-strong m-0"
							data-qa="local-heading"
						>
							<Translate value="corgi.local.page_heading.title" replacements={{ location: displayName }} />
						</Text>

						<LocalStats />

						<Button
							data-qa="header-sap-button"
							className="max-md:mx-auto max-md:w-full"
							as="a"
							href="/start-a-petition?source_location=local_page"
							variant="primary"
							size="large"
						>
							<Translate value="corgi.local.page_heading.start_button" />
						</Button>
					</div>
				</div>
			</HeroLayout>
		</div>
	);
};
